import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs';
import { LocalStorageService } from 'ngx-webstorage';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class ContragentRefService {
  contragentRefs = new ReplaySubject<string[]>(1);
  maxRefsAmount = 10;

  CONTRAGENT_REFS_STORAGE_KEY = `contragentRefs_${this.authService.user.userLogin}`;

  constructor(
    private storage: LocalStorageService,
    private authService: AuthService,
  ) {
    const refs = storage.retrieve(this.CONTRAGENT_REFS_STORAGE_KEY);
    if (refs) {
      this.contragentRefs.next(
        refs.length <= this.maxRefsAmount
          ? refs
          : refs.slice(0, this.maxRefsAmount),
      );
    }
  }

  getSelectedContragentRefs(): string[] {
    return this.storage.retrieve(this.CONTRAGENT_REFS_STORAGE_KEY) || [];
  }

  updateContrangentRefs(refs: string[]) {
    this.CONTRAGENT_REFS_STORAGE_KEY = `contragentRefs_${this.authService.user.userLogin}`;
    this.storage.store(this.CONTRAGENT_REFS_STORAGE_KEY, refs);
    this.contragentRefs.next(
      refs.length <= this.maxRefsAmount
        ? refs
        : refs.slice(0, this.maxRefsAmount),
    );
  }

  getContragentRefs(): Observable<string[]> {
    this.CONTRAGENT_REFS_STORAGE_KEY = `contragentRefs_${this.authService.user.userLogin}`;
    return this.contragentRefs.asObservable().pipe(distinctUntilChanged());
  }
}
